import { isBilltoro } from '../produkt';
import type { Me } from '../types';

// Wohin nach der Anmeldung? Auf die Seite, die vorher aufgerufen wurde (z. B. Link aus der E-Mail „Neue Registrierung“
// oder nach Ablauf der Sitzung), sonst auf die Startseite. Nur Seiten der eigenen App, nie eine fremde Adresse.
// Billtoro hat nur das Rechnungswerkzeug, dazu „Ihre Mandanten“ für Logins mit Zugang fürs Steuerbüro und den
// Betreiber-Bereich für den Betreiber (ohne eigene Firma jeweils die Startseite).
export function homeOf(me: Me): string {
  if (isBilltoro()) {
    if (!me.clients.length && me.betreiber) return '/betreiber';
    return me.buero && !me.clients.length ? '/mandanten' : '/rechnung';
  }
  return me.user.kind === 'staff' ? '/kanzlei' : '/app';
}

export function afterLogin(state: unknown, me: Me): string {
  const home = homeOf(me);
  const from = (state as { from?: unknown } | null)?.from;
  if (typeof from !== 'string' || /\/\/|\\/.test(from)) return home;
  // Mandanten auch zurück ins Rechnungswerkzeug (/rechnung, eigene Seite); Billtoro: zurück zur Einladung ins Team, zu
  // den Mandanten des Steuerbüros und (nur der Betreiber) in den Betreiber-Bereich, z. B. nach „Neu anmelden“ dort
  const billtoro = isBilltoro() ? ['/einladung', '/mandanten', ...(me.betreiber ? ['/betreiber'] : [])] : [];
  const areas = me.user.kind === 'client' ? [home, '/rechnung', ...billtoro] : [home];
  const own = areas.some((a) => from === a || ['/', '?', '#'].some((sep) => from.startsWith(a + sep)));
  return own ? from : home;
}
